import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import { Form } from "informed";
import firebase from "firebase/app";
import "firebase/auth";
import { TextInput, SelectInput, CheckBox } from "../shared/Forms";
import * as constants from "../../constants";

class Activate extends Component {
	constructor(props) {
		super(props);
		this.userId = props.match.params.userId;
		this.appKey = props.match.params.appKey;
		this.state = {
			user: null,
			values: null,
			confirmed: false,
			addPassword: false,
			error: null,
		};
	}

	componentDidMount() {
		var api = axios.create({
			baseURL: constants.BASE_API_URL,
			timeout: 20000,
		});
		api.get(`/users/${this.userId}`)
			.then(res => {
				if (res.data.isActivated) {
					this.props.history.push("/apps");
				} else {
					let user = Object.assign(
						{},
						{
							id: res.data.publicId,
							firstName: res.data.firstName,
							lastName: res.data.lastName,
							email: res.data.email,
							timeZoneId: res.data.timeZoneId,
							optedIn: false,
						}
					);

					this.setState({ user });
				}
			})
			.catch(error => {
				console.log(error);
			});
	}

	submitForm = values => {
		localStorage.setItem("activateUser", JSON.stringify(values));
		this.setState({ values, confirmed: true });
		//this.props.history.push(`/apps/${this.appKey}`);
	};

	logInWithGoogle = () => {
		var provider = new firebase.auth.GoogleAuthProvider();
		localStorage.setItem("preventUserSignout", "true");
		firebase
			.auth()
			.signInWithPopup(provider)
			.then(() => {
				this.props.history.push(`/apps/${this.appKey}`);
			});
	};

	pickEmail = () => {
		this.setState({ addPassword: true });
	};

	submitPassword = values => {
		let { password } = values;
		let email = this.state.values.email;
		localStorage.setItem("preventUserSignout", "true");
		firebase
			.auth()
			.createUserWithEmailAndPassword(email, password)
			.then(() => {
				this.props.history.push(`/apps/${this.appKey}`);
			})
			.catch(error => {
				// Handle Errors here.
				var errorCode = error.code;
				var errorMessage = error.message;
				if (errorCode === "auth/weak-password") {
					this.setState({ error: "The password is too weak" });
				} else {
					this.setState({ error: errorMessage });
				}
			});
	};

	render() {
		const { user } = this.state;
		const timezoneOptions = [];
		if (this.props.timezones) {
			this.props.timezones.forEach(timezone => {
				timezoneOptions.push({
					key: timezone.id,
					value: timezone.id,
					label: timezone.name,
				});
			});
		}
		return (
			<div className="log-in-window">
				<div className="log-in-window-content">
					<div className="box">
						<h3 className="page-title">{"Let's Get Started"}</h3>
						{this.state.error && <div className="error">{this.state.error}</div>}
						{user && timezoneOptions.length > 0 && (
							<div>
								<div className={`content-toggle ${!this.state.confirmed ? "on" : "off"}`}>
									<h5>Confirm your info:</h5>
									<Form id="activate-form" initialValues={user} onSubmit={this.submitForm}>
										<TextInput id="firstName" field="firstName" placeholder="First Name" />
										<TextInput id="lastName" field="lastName" placeholder="Last Name" />
										<TextInput id="email" field="email" placeholder="Email Address" />
										<SelectInput
											id="timeZoneId"
											field="timeZoneId"
											values={timezoneOptions}
											placeholder="Timezone"
											isRequired={true}
										/>
										<CheckBox id="optedIn" field="optedIn" label="Opt In" />
										<button className="btn btn-primary">Continue</button>
									</Form>
								</div>
								<div
									className={`content-toggle ${
										this.state.confirmed && !this.state.addPassword ? "on" : "off"
									}`}
								>
									<h5>{"How would you like to log in?"}</h5>
									<div className="p-top p-bottom">
										<div
											onClick={this.logInWithGoogle}
											className="btn login-option m-right m-top m-bottom"
										>
											<i className="fab fa-google"></i>
										</div>
										<div onClick={this.pickEmail} className="btn login-option m-top m-bottom">
											<i className="fal fa-envelope"></i>
										</div>
									</div>
								</div>
								<div
									className={`content-toggle ${
										this.state.confirmed && this.state.addPassword ? "on" : "off"
									}`}
								>
									<h5>{"Add Your Password"}</h5>
									<div className="p-top p-bottom">
										<Form id="password-form" onSubmit={this.submitPassword}>
											<TextInput
												id="password"
												field="password"
												placeholder="Password"
												type="password"
												onValueChange={() => this.setState({ error: null })}
											/>
											<button className="btn btn-primary">Finish</button>
										</Form>
									</div>
								</div>
							</div>
						)}
					</div>
				</div>
			</div>
		);
	}
}
Activate.propTypes = {
	match: PropTypes.any,
	timezones: PropTypes.any,
	history: PropTypes.any,
};

function mapStateToProps(state) {
	return {
		auth: state.auth,
		timezones: state.controlPanel.timezones,
	};
}

export default connect(mapStateToProps)(Activate);
